/// \file alertsManagement.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const AlertsManagementList = lazy(() => import('../views/alerts-management/list/view'));

async function alertsManagementDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/alerts-management/list/loader')).default;
  return actualLoader(args);
}

export async function alertsManagementAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/alerts-management/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="alertsManagement"
    handle={{
      text:"ALERTS MANAGEMENT"
    }}
  >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <AlertsManagementList />
        </Suspense>
      }
      loader={alertsManagementDataLoader}
      action={alertsManagementAction}
      />
  </Route>
);

export default routes;